var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpBubble(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0C4.25823 0 0 3.81 0 8.5C0 13.19 4.25823 17 9.5 17H10.0588V20C15.4906 17.66 19 13 19 8.5C19 3.81 14.7418 0 9.5 0ZM10.6176 14.5H8.38235V12.5H10.6176V14.5ZM10.6176 11H8.38235C8.38235 7.75 11.7353 8 11.7353 6C11.7353 4.9 10.7294 4 9.5 4C8.27059 4 7.26471 4.9 7.26471 6H5.02941C5.02941 3.79 7.03 2 9.5 2C11.97 2 13.9706 3.79 13.9706 6C13.9706 8.5 10.6176 8.75 10.6176 11Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpBubble);
export default __webpack_public_path__ + "static/media/helpBubble.8c92015047bf71a3bd3101b8914dc6fb.svg";
export { ForwardRef as ReactComponent };